// src/lib/opportunity/formatProposalContactClient.ts

import { opportunityFetch } from "./opportunityFetch.js";
import type { OpportunityFormatKey } from "../../types/opportunity.js";
import type { FormatProposalContact } from "./proposalContactTypes.js";

export function getFormatProposalContact(filters: {
  format_key: OpportunityFormatKey;
  product_type: string;
}) {
  const q = new URLSearchParams({
    format_key: filters.format_key,
    product_type: filters.product_type,
  });
  return opportunityFetch<{ ok: true; contact: FormatProposalContact | null }>(
    `/api/opportunity/format-proposal-contact-get?${q.toString()}`,
    { method: "GET" },
  );
}

export type UpsertFormatProposalContactPayload = {
  format_key: OpportunityFormatKey;
  product_type: string;
  org_name: string | null;
  person_name: string | null;
  address: string | null;
  phone: string | null;
  email: string | null;
  allow_rep_contact_override: boolean;
};

export function upsertFormatProposalContact(payload: UpsertFormatProposalContactPayload) {
  return opportunityFetch<{ ok: true; contact: FormatProposalContact }>(
    "/api/opportunity/format-proposal-contact-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}
